<app-card-shell padding="lg">
  <section
    class="sales-order-history-tab"
    [attr.aria-label]="'COMPONENTS.SALES_ORDERS.HISTORY.TITLE' | translate"
  >
    <header class="sales-order-history-tab__header">
      <h2 class="sales-order-history-tab__title">
        {{ 'COMPONENTS.SALES_ORDERS.HISTORY.TITLE' | translate }}
      </h2>
    </header>

    @if (isLoading) {
      <div class="sales-order-history-tab__state" role="status" aria-live="polite">
        {{ 'MESSAGES.LOADING' | translate }}
      </div>
    } @else if (errorKey) {
      <div class="sales-order-history-tab__state sales-order-history-tab__state--error" role="alert">
        {{ errorKey | translate }}
      </div>
    } @else if (historyEntries.length) {
      <div class="sales-order-history-tab__list">
        @for (entry of historyEntries; track entry.id) {
          <article class="sales-order-history-tab__item">
            <div class="sales-order-history-tab__item-marker" aria-hidden="true">
              <span class="sales-order-history-tab__item-dot" [ngClass]="entry.dotClass"></span>
            </div>

            <div class="sales-order-history-tab__item-head">
              <div class="min-w-0">
                <p class="sales-order-history-tab__item-title">{{ entry.summaryKey | translate: entry.summaryParams }}</p>
                <p class="sales-order-history-tab__item-person">{{ entry.initiator }}</p>
              </div>

              <p class="sales-order-history-tab__item-date">{{ entry.createdAt | date: 'dd.MM.yyyy HH:mm' }}</p>
            </div>

            @if (entry.diffRows.length) {
              <div class="sales-order-history-tab__item-body">
                @for (row of entry.diffRows; track row.id) {
                  <div class="sales-order-history-tab__diff-row">
                    <p class="sales-order-history-tab__diff-label">{{ row.labelKey | translate }}</p>
                    <p class="sales-order-history-tab__diff-value">
                      @if (row.showOldValue && row.oldValue) {
                        <span class="sales-order-history-tab__diff-value sales-order-history-tab__diff-value--old">
                          @if (row.oldValue.translationKey) {
                            {{ row.oldValue.translationKey | translate }}
                          } @else {
                            {{ row.oldValue.text }}
                          }
                        </span>
                        <span class="sales-order-history-tab__diff-arrow">→</span>
                      }
                      <span class="sales-order-history-tab__diff-value sales-order-history-tab__diff-value--new">
                        @if (row.newValue.translationKey) {
                          {{ row.newValue.translationKey | translate }}
                        } @else {
                          {{ row.newValue.text }}
                        }
                      </span>
                    </p>
                  </div>
                }
              </div>
            }
          </article>
        }
      </div>
    } @else {
      <div class="sales-order-history-tab__empty">
        {{ 'COMPONENTS.SALES_ORDERS.HISTORY.EMPTY' | translate }}
      </div>
    }
  </section>
</app-card-shell>
